export const MESSAGES: { [key: string]: { success: string; error: string } } = {
  'trv.temperature_setTargetTemperature': { success: '', error: '' },
  'heating.dhw.temperature.main_setTargetTemperature': { success: '', error: '' },
  'heating.dhw.temperature.temp2_setTargetTemperature': { success: '', error: '' },
  'heating.dhw.temperature.hysteresis_setHysteresis': { success: '', error: '' },
  'heating.dhw.oneTimeCharge_activate': { success: '', error: '' },
  'heating.dhw.oneTimeCharge_deactivate': { success: '', error: '' },
  'heating.dhw.schedule_setSchedule': { success: '', error: '' },
  'heating.dhw.pumps.circulation.schedule_setSchedule': { success: '', error: '' },
  'heating.circuits.dhw.schedule_setSchedule': { success: '', error: '' },
  'heating.circuits.circulation.schedule_setSchedule': { success: '', error: '' },
  'heating.circuits.heating.schedule_setSchedule': { success: '', error: '' },
  'heating.circuits.operating.modes.active_setMode': { success: '', error: '' },
  'heating.circuits.operating.programs.holiday_schedule': { success: '', error: '' },
  'heating.circuits.operating.programs.holiday_unschedule': { success: '', error: '' },
  'heating.circuits.operating.programs.eco_activate': { success: '', error: '' },
  'heating.circuits.operating.programs.comfort_activate': { success: '', error: '' },
  'heating.circuits.operating.programs.eco_deactivate': { success: '', error: '' },
  'heating.circuits.operating.programs.comfort_deactivate': { success: '', error: '' },
  'heating.circuits.heating.curve_setCurve': {
    success: '',
    error: '',
  },
};
